module.exports = __webpack_public_path__ + "img/am-4-of-july-2021-pre-campaign.752d3cc6.jpg";